import Axios from "axios";
import { WebFramework, decrypt, getDomain } from "../../Utilities/utils";
import {
  CHECK_PAYMENT_STATUS_API_ENDPOINT,
  SEND_PAYMENT_LINK_TO_CUSTOMER_API_ENDPOINT,
  TRANSFER_DATA_API_ENDPOINT,
} from "../apiConfig";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import handlePayHereForRelianceIPA from "./Helpers/handlePayHereForRelianceIPA";
import {
  PAYMENT_PAGE_FOR_CUSTOMER_ROUTE,
  POLICY_STATUS_ROUTE,
  QUICK_QUOTE_ROUTE,
} from "../routes";

export const POLICY_STATUS = {
  QUICK_QUOTE_SUBMISSION: 1,
  CREATE_QUOTE_SUBMISSION: 2,
  POLICY_GENERATION: 3,
  PAYMENT_FAILURE: 4,
  UNDERWRITING: 5,
  REJECTION: 6,
  PAYMENT_SUCCESS: 7,
};

// TODO: Make code better
const usePaymentOptions = () => {
  const { transferDataId } = useParams();
  let decryptedTransferDataId = null;
  if (transferDataId) {
    decryptedTransferDataId = decrypt(decodeURIComponent(transferDataId));
  }
  const [transferData, setTransferData] = useState({});
  const [sentSMS, setSentSMS] = useState(false);
  const [msgForSMSButton, setMsgForSMSButton] = useState(
    "Send payment link to customer" // TODO: not better
  );
  const navigate = useNavigate();

  const { state } = useLocation();
  const { premiumAmount, grossPremiumAmount, serviceTaxAmount } = state ?? {};

  const [clickedPayHere, setClickedPayHere] = useState(false);
  const [nextButtonStatus, setNextButtonStatus] = useState(false);
  const [sendLinkButtonClicked, setSendLinkButtonClicked] = useState(false);

  useEffect(() => {
    const domain = getDomain();
    // Get transfer data
    Axios.get(
      `${domain}${TRANSFER_DATA_API_ENDPOINT}/${
        decryptedTransferDataId || transferDataId // Handle both cases 1. when user comes from portal transfer data id is decrypted 2. when user comes directly to payment page transfer data id is not decrypted
      }`
    ).then((response) => {
      console.log("Transfer data response", response);
      setTransferData(response.data);
    });
  }, [transferDataId, decryptedTransferDataId]);

  const backButtonHandler = () => {
    Swal.fire({
      title: "Proposal already generated",
      text: "Proceed to payment or go back to quick quote.",
      icon: "warning",
      confirmButtonColor: "#0d409b",
      cancelButtonColor: "#d33",
      confirmButtonText: "Proceed to Payment",
      cancelButtonText: "Go to Quick Quote",
      showCancelButton: true,

      reverseButtons: true,
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.cancel) {
        navigate(QUICK_QUOTE_ROUTE);
      }
    });
  };

  const sendPaymentLinkToCustomer = async () => {
    setSendLinkButtonClicked(true);
    const domain = getDomain();

    try {
      const paymentPageUrlForCustomer =
        getDomain(WebFramework.REACT) + PAYMENT_PAGE_FOR_CUSTOMER_ROUTE + "/"; // TODO: change this
      const response = await Axios.get(
        `${domain}${SEND_PAYMENT_LINK_TO_CUSTOMER_API_ENDPOINT}/${
          transferData.A_id
        }/${
          transferData.Acuvisor_product_id
        }/${decryptedTransferDataId}/?paymentpageurl=${encodeURIComponent(
          paymentPageUrlForCustomer
        )}`
      );
      console.log("Send Payment Link API Response", response);
      if (response?.data[0]?.status) {
        setSentSMS(true);
        setMsgForSMSButton("A sms will be sent to the customer");
      } else {
        setSentSMS(false);
        setSendLinkButtonClicked(false);
        setMsgForSMSButton("SMS sent failed, try again");
      }
    } catch (err) {
      console.log("Error in sending payment link to customer", err);
      setSentSMS(false);
      setSendLinkButtonClicked(false);
      setMsgForSMSButton("SMS sent failed, try again");
    }
  };

  const handleCloseSlack = (event, reason) => {
    if (reason === "clickaway") return;
    setSentSMS(false);
  };

  const handlePayHere = () => {
    setClickedPayHere(true);
    if (transferData?.product_name === "Reliance IPA") {
      console.log(" transferData?.paymentUrl: ", transferData?.paymentUrl);
      handlePayHereForRelianceIPA(setClickedPayHere, transferData?.paymentUrl);
    }
  };

  const checkPaymentStatus = async () => {
    const domain = getDomain();
    try {
      const response = await Axios.get(
        `${domain}${CHECK_PAYMENT_STATUS_API_ENDPOINT}/${transferData.A_id}/`
      );
      console.log("Check Status", response);
      if (response?.data?.policyStatus === POLICY_STATUS.PAYMENT_SUCCESS) {
        setNextButtonStatus(true);
        Swal.fire({
          icon: "success",
          title: "Your Transaction is successfull",
          position: "center",
        }).then((result) => {
          console.log("swl", result);
        });
      } else if (response.data.policyStatus === POLICY_STATUS.PAYMENT_FAILURE) {
        Swal.fire({
          icon: "warning",
          title: "Payment Transaction Failed !",
          text: "User payment transaction has failed ,Try again !",
          position: "center",
        });
        setSentSMS(false);
        setMsgForSMSButton("Send Link to Customer Again !");
        setSendLinkButtonClicked(false);
      } else {
        Swal.fire({
          icon: "warning",
          title: "Check the status again after 10 mins",
          position: "center",
        });
      }
    } catch (error) {
      console.log("error: ", error);
      alert("Something went wrong, try again after sometimes..");
    }
  };

  const nextHandler = async () => {
    // Navigate to policy status page
    navigate(`${POLICY_STATUS_ROUTE}/${decryptedTransferDataId}/`);
  };

  return {
    transferData,
    sentSMS,
    checkPaymentStatus,
    nextButtonStatus,
    sendLinkButtonClicked,
    nextHandler,
    sendPaymentLinkToCustomer,
    msgForSMSButton,
    clickedPayHere,
    handleCloseSlack,
    handlePayHere,
    backButtonHandler,
    premiumAmount,
    grossPremiumAmount,
    serviceTaxAmount,
  };
};

export default usePaymentOptions;
